import { useEffect, useState } from "react";
import { CheckCircle2, PartyPopper } from "lucide-react";

const COLORS = ["#FF7A00", "#FF3B30", "#002244", "#25D366", "#f59e0b", "#0a3a63"];

export default function Celebration({ open, title = "Congratulations!", message, amount, onClose, cta = "View My Booking" }) {
  const [pieces, setPieces] = useState([]);
  useEffect(() => {
    if (!open) return;
    setPieces(Array.from({ length: 60 }).map((_, i) => ({
      id: i, left: Math.random() * 100, delay: Math.random() * 0.6,
      dur: 2 + Math.random() * 1.8, color: COLORS[i % COLORS.length],
      size: 6 + Math.random() * 8, rot: Math.random() * 360,
    })));
  }, [open]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-navy/60 px-4 backdrop-blur-sm" data-testid="celebration-modal">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        {pieces.map((p) => (
          <span key={p.id} className="confetti-piece" style={{
            left: `${p.left}%`, background: p.color, width: p.size, height: p.size * 0.4,
            animationDelay: `${p.delay}s`, animationDuration: `${p.dur}s`, transform: `rotate(${p.rot}deg)`,
          }} />
        ))}
      </div>
      <div className="relative w-full max-w-md rounded-3xl bg-white p-8 text-center shadow-2xl fade-up">
        <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full brand-gradient">
          <PartyPopper className="h-10 w-10 text-white" />
        </div>
        <h2 className="font-display text-3xl font-extrabold text-navy">{title}</h2>
        <p className="mt-2 text-gray-500">{message}</p>
        {amount != null && (
          <div className="mt-5 flex items-center justify-center gap-2 rounded-2xl bg-emerald-50 py-3 text-emerald-700">
            <CheckCircle2 className="h-5 w-5" /> <span className="font-bold">₹{Number(amount).toLocaleString("en-IN")} paid successfully</span>
          </div>
        )}
        <button onClick={onClose} data-testid="celebration-cta" className="btn-gradient mt-6 w-full rounded-full py-3.5 font-bold">{cta}</button>
      </div>
    </div>
  );
}
